export default __webpack_public_path__ + "static/Willoughby-240accc509d7bd5d9ff856a423cbb692.jpg";